export default function simulator() {
  var portionResultSelect, portionResultMonello, portionResultBirbo
  var productDataSelect, productDataMonello, productDataBirbo
  var formValues = {}

  choosePet()
  choosePhase()
  fillWeight()
  fillPuppyNumber()
  fillCatOverWeightNumber()
  fillDogOverWeightNumber()
  chooseAgeAdultDog()
  chooseAgePuppyDog()
  chooseLactatingWeeksDog()
  chooseCastratedCat()
  chooseOverweightCat()
  chooseOverweightDog()

  function showPhase() {
    $('.fase').fadeIn()
  }

  function showWeight() {
    $('.weight-container').fadeIn()
  }

  function showInformationWeight() {
    $('.weight-container p').fadeIn()
  }

  function showAgeAdultDog() {
    $('.age-adult-dog').fadeIn()
  }

  function showAgePuppyDog() {
    $('.age-puppy').fadeIn()
  }

  function showProductResult() {
    $('section.simulator .result').fadeIn()
    $('section.simulator .simulator-recomandation').fadeIn()
  }

  function showPuppyNumber() {
    $('section.simulator .puppy-number').fadeIn()
  }

  function showLactatingWeeks() {
    $('section.simulator .age-lactating-dog').fadeIn()
  }

  function showCastratedCat() {
    $('section.simulator .castrated-cat').css('display', 'grid')
  }

  function showOverweightDog() {
    $('section.simulator .overweight-adult-dog').css('display', 'grid')
  }

  function showDesiredWeightDog() {
    $('section.simulator .overweight-container.adult-dog').fadeIn()
  }

  function hideOverweightDog() {
    $('section.simulator .overweight-adult-dog').fadeOut()
  }

  function hideDesiredWeightDog() {
    $('section.simulator .overweight-container.adult-dog').fadeOut()
  }

  function showOverweightCat() {
    $('section.simulator .overweight-cat').css('display', 'grid')
  }

  function showDesiredWeight() {
    $('section.simulator .overweight-container.cat').fadeIn()
  }

  function hideCastratedCat() {
    $('section.simulator .castrated-cat').fadeOut()
  }

  function hideOverweightCat() {
    $('section.simulator .overweight-cat').fadeOut()
  }

  function hideDesiredWeight() {
    $('section.simulator .overweight-container.cat').fadeOut()
  }

  function hidePhase() {
    $('.fase').fadeOut()
  }

  function hideWeight() {
    $('.weight-container').fadeOut()
  }

  function hideInformationWeight() {
    $('.weight-container p').fadeOut()
  }

  function hideAgeAdultDog() {
    $('.age-adult-dog').fadeOut()
  }

  function hideAgePuppyDog() {
    $('.age-puppy').fadeOut()
  }

  function hideProductResult() {
    $('section.simulator .result').fadeOut()
    $('section.simulator .simulator-recomandation').fadeOut()
  }

  function hidePuppyNumber() {
    $('section.simulator .puppy-number').fadeOut()
  }

  function hideLactatingWeeks() {
    $('section.simulator .age-lactating-dog').fadeOut()
  }

  function hideAllAges() {
    hideAgePuppyDog()
    hideAgeAdultDog()
  }

  function resetPhase() {
    $('.fase li').removeClass('active')
    $('input[name="phase"]').prop('checked', false)
  }

  function resetWeight() {
    $('input[name="weight"]').val('')
  }

  function resetPuppyNumber() {
    $('input[name="puppy-number"]').val('')
  }

  function resetLactatingWeeks() {
    $('.age-lactating-dog li').removeClass('active')
    $('.age-lactating-dog input[name="lactating-week"]').prop('checked', false)
  }

  function resetAgeAdultDog() {
    $('.age-adult-dog li').removeClass('active')
    $('.age-adult-dog input[name="age"]').prop('checked', false)
  }

  function resetAgePuppyDog() {
    $('.age-puppy li').removeClass('active')
    $('.age-puppy input[name="age"]').prop('checked', false)
  }

  function resetCastratedCat() {
    $('.castrated-cat li').removeClass('active')
    $('.castrated-cat input[name="castrated"]').prop('checked', false)
  }

  function resetOverweightCat() {
    $('.overweight-cat li').removeClass('active')
    $('.overweight-cat input[name="overweight"]').prop('checked', false)
  }

  function resetOverweightDog() {
    $('.overweight-adult-dog li').removeClass('active')
    $('.overweight-adult-dog input[name="overweight-dog"]').prop('checked', false)
  }

  function resetOverweightNumberCat() {
    $('input[name="overweight-number"]').val('')
  }

  function resetOverweightNumberDog() {
    $('input[name="overweight-dog-number"]').val('')
  }

  function resetAllAges() {
    resetAgeAdultDog()
    resetAgePuppyDog()
  }

  function choosePet() {
    $('input[name="pet"]').on('change', function() {
      $('.animal .row-line').removeClass('active')
      $(this)
        .parent('.row-line')
        .addClass('active')

      resetPhase()
      resetWeight()
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightNumberCat()
      resetOverweightDog()
      resetOverweightCat()
      resetCastratedCat()
      resetOverweightNumberDog()

      hideWeight()
      hideInformationWeight()
      hideAllAges()
      hideProductResult()
      hidePuppyNumber()
      hideLactatingWeeks()
      hideDesiredWeight()
      hideOverweightCat()
      hideOverweightDog()
      hideCastratedCat()
      hideDesiredWeightDog()

      showPhase()
      getFormValues()
    })
  }

  function choosePhase() {
    $('input[name="phase"]').on('change', function() {
      $('.fase li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetWeight()
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightNumberCat()
      resetOverweightDog()
      resetOverweightCat()
      resetCastratedCat()
      resetOverweightNumberDog()

      hideAllAges()
      hideProductResult()
      hidePuppyNumber()
      hideLactatingWeeks()
      hideDesiredWeight()
      hideOverweightDog()
      hideOverweightCat()
      hideCastratedCat()
      hideDesiredWeightDog()

      showWeight()
      getFormValues()

      if (formValues.petValue == 'dog') {
        if (formValues.phaseValue == 'puppies') {
          showInformationWeight()
        } else {
          hideInformationWeight()
        }
      }
    })
  }

  function fillWeight() {
    $('input[name="weight"]').on('input', function() {
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightDog()
      resetOverweightNumberDog()

      hideLactatingWeeks()
      hideDesiredWeightDog()
      hideAgeAdultDog()

      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        if (formValues.petValue == 'dog' && formValues.phaseValue == 'adults') {
          hideProductResult()
          showOverweightDog()
        } else if (formValues.petValue == 'dog' && formValues.phaseValue == 'puppies') {
          hideProductResult()
          showAgePuppyDog()

          if (valor < 12) {
            $('.age-puppy-4').hide()
          } else if (valor >= 12) {
            $('.age-puppy-4').show()
          }
        } else if (formValues.petValue == 'dog' && formValues.phaseValue == 'pregnant') {
          formulas()
        } else if (formValues.petValue == 'dog' && formValues.phaseValue == 'lactating') {
          hideProductResult()
          showPuppyNumber()
        } else if (formValues.petValue == 'cat' && formValues.phaseValue == 'puppies') {
          hideProductResult()
          showAgePuppyDog()
          $('.age-puppy-4').hide()
        } else if (formValues.petValue == 'cat' && formValues.phaseValue == 'adults') {
          resetCastratedCat()
          resetOverweightCat()
          resetOverweightNumberCat()

          hideProductResult()
          hideOverweightCat()
          hideDesiredWeight()

          showCastratedCat()
        } else if (formValues.petValue == 'cat' && formValues.phaseValue == 'pregnant') {
          formulas()
        } else if (formValues.petValue == 'cat' && formValues.phaseValue == 'lactating') {
          formulas()
        }
      } else {
        hideAllAges()
        hidePuppyNumber()

        resetCastratedCat()
        resetOverweightCat()
        resetOverweightNumberCat()

        hideProductResult()
        hideCastratedCat()
        hideOverweightDog()
        hideOverweightCat()
        hideDesiredWeight()
      }
    })
  }

  function fillPuppyNumber() {
    $('input[name="puppy-number"]').on('input', function() {
      hideProductResult()

      resetLactatingWeeks()

      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        showLactatingWeeks()
      } else {
        hideLactatingWeeks()
      }
    })
  }

  function fillCatOverWeightNumber() {
    $('input[name="overweight-number"]').on('input', function() {
      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        formulas()
      } else {
        hideProductResult()
      }
    })
  }

  function fillDogOverWeightNumber() {
    $('input[name="overweight-dog-number"]').on('input', function() {
      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        formulas()
      } else {
        hideProductResult()
      }
    })
  }

  function chooseAgeAdultDog() {
    $('.age-adult-dog input[name="age"]').on('change', function() {
      $('.age-adult-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseAgePuppyDog() {
    $('.age-puppy input[name="age"]').on('change', function() {
      $('.age-puppy li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseLactatingWeeksDog() {
    $('input[name="lactating-week"]').on('change', function() {
      $('.age-lactating-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseCastratedCat() {
    $('input[name="castrated"]').on('change', function() {
      $('.castrated-cat li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetOverweightCat()
      resetOverweightNumberCat()

      showOverweightCat()

      hideDesiredWeight()
      hideProductResult()

      getFormValues()
    })
  }

  function chooseOverweightCat() {
    $('.overweight-cat li input[name="overweight"]').on('change', function() {
      $('.overweight-cat li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetOverweightNumberCat()
      hideProductResult()

      getFormValues()

      if (formValues.overweightValue == '1') {
        showDesiredWeight()
      } else {
        hideDesiredWeight()
      }

      formulas()
    })
  }

  function chooseOverweightDog() {
    $('.overweight-adult-dog li input[name="overweight-dog"]').on('change', function() {
      $('.overweight-adult-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetAllAges()
      resetOverweightNumberDog()

      hideAgeAdultDog()
      hideProductResult()

      getFormValues()

      if (formValues.overweightDogValue == '1') {
        showDesiredWeightDog()
      } else {
        hideDesiredWeightDog()
        showAgeAdultDog()

        if (formValues.weightValue < 12) {
          $('.age-adult-dog .age').html('7')
        } else if (formValues.weightValue >= 12) {
          $('.age-adult-dog .age').html('5')
        }
      }
    })
  }

  function getFormValues() {
    formValues['petValue'] = $('input[name="pet"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['phaseValue'] = $('input[name="phase"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['ageValue'] = $('input[name="age"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['lactatingWeekValue'] = $('input[name="lactating-week"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['castratedValue'] = $('input[name="castrated"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['overweightValue'] = $('input[name="overweight"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['overweightDogValue'] = $('input[name="overweight-dog"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['weightValue'] = $('input[name="weight"').val()
    formValues['puppyValue'] = $('input[name="puppy-number"').val()
    formValues['overweightNumberValue'] = $('input[name="overweight-number"').val()
    formValues['overweightDogNumberValue'] = $('input[name="overweight-dog-number"').val()

    console.log(formValues)
  }

  async function formulas() {
    getFormValues()

    // Define o body com base no valor de petValue
    const body =
      formValues.petValue === 'cat'
        ? {
            pet: formValues.petValue,
            age: formValues.ageValue,
            castrated: formValues.castratedValue,
            overweight: formValues.overweightValue,
            weight: formValues.weightValue,
            ideal_weight: formValues.overweightNumberValue,
            phase: formValues.phaseValue,
            lactating_week: formValues.lactatingWeekValue,
            lactating_puppies: formValues.puppyValue,
          }
        : {
            pet: formValues.petValue,
            age: formValues.ageValue,
            castrated: formValues.castratedValue,
            overweight: formValues.overweightDogValue,
            weight: formValues.weightValue,
            ideal_weight: formValues.overweightDogNumberValue,
            phase: formValues.phaseValue,
            lactating_week: formValues.lactatingWeekValue,
            lactating_puppies: formValues.puppyValue,
          }

    console.log(body)

    try {
      const response = await fetch('https://nutrire.ind.br/api/simulator', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        throw new Error('Erro ao calcular as fórmulas')
      }

      const data = await response.json()
      console.log(data)
      updateView(data)
    } catch (error) {
      console.error('Erro na solicitação:', error)
    }
  }

  function scrollResult() {
    $('html, body').animate(
      {
        scrollTop: $('.result h1').offset().top - 110,
      },
      1000
    )
  }

  function updateView(data) {
    showProductResult()
    scrollResult()

    const swiperWrapper = document.querySelector('.simulator-recomandation-swiper .swiper-wrapper')
    swiperWrapper.innerHTML = ''

    if (data.length > 0) {
      // Usa o primeiro produto para o bloco principal
      const firstProduct = data[0]
      $('section.simulator .result-part').html(`${firstProduct.portion}`)
      $('section.simulator .result-image img').attr('src', firstProduct.image.link)
      $('section.simulator .result-text-container h4').html(`${firstProduct.brand} - ${firstProduct.title}`)
      $('section.simulator .result-link-button').attr('href', firstProduct.slug)
      $('section.simulator .result-link-button').css('background-color', firstProduct.hexadecimal)
      $('section.simulator .result-text-container h5 p').css('color', firstProduct.hexadecimal)
      $('section.simulator .result-text-container h5 p').css('border-color', firstProduct.hexadecimal)
      $('section.simulator .result-text-container h5 p span').css('color', firstProduct.hexadecimal)
      $('.result h1').css('color', firstProduct.hexadecimal)

      // Adiciona os produtos ao swiper
      data.slice(1).forEach(product => {
        const productHTML = `
                <li class="swiper-slide column">
                    <a href="${product.slug}" class="column">
                        <div class="illustration">
                            <img
                                src="${product.image.link}"
                                alt="${product.title}"
                                loading="lazy" />
                        </div>
                        <p>${product.brand} - ${product.title}</p>
                        <button class="button-orange">
                            <p>Ver Produto</p>
                        </button>
                    </a>
                    <div class="column">
                        <h5><strong>Dose diária</strong> Recomendada:</h5>
                        <p class="row">
                            <span>${product.portion}</span> gramas
                        </p>
                    </div>
                </li>
            `
        swiperWrapper.insertAdjacentHTML('beforeend', productHTML)
      })
    }

    // Reconfigura o Swiper para reconhecer os novos elementos
    if (typeof Swiper !== 'undefined') {
      new Swiper('.simulator-recomandation-swiper.swiper', {
        modules: [Navigation, EffectFade],
        loop: true,
        allowTouchMove: true,
        spaceBetween: 20,
        breakpoints: {
          680: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: '.simulator-recomandation .swiper-button-next',
          prevEl: '.simulator-recomandation .swiper-button-prev',
        },
      })
    }

    // Exibe o container de resultados
    document.querySelector('section.simulator .result').style.display = 'block'
    document.querySelector('section.simulator .simulator-recomandation').style.display = 'block'
  }
}
